import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET ALL TODOS ******
export const getAllTodosForEmployee =
  (employeeKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        todos?: {
          _id: string;
          createdAt: Date | string;
          files: string[];
          title: string;
          description: string;
          recipients: {
            _id: string;
            name: string;
          }[];
          tasks: {
            _id: string;
            createdAt: string | Date;
            files: string[];
            recipient: string;
            status: string;
            description: string;
          }[];
          deadline: string | Date;
        }[];
      }>(`/todo/employee/fetch/all`, dates, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Status of a todo ******
export const getStatusOfTodoForEmployee =
  (employeeKey: string) => (todoId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        foundstatus: {
          status: string;
          employee: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/todo/fetch/status/${todoId}`, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET a todo ******
export const getTodoForEmployee = (employeeKey: string) => (todoId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      todo: {
        createdAt: string | Date;
        deadline: string | Date;
        description: string;
        files?: string[];
        title: string;
        tasks?: {
          _id: string;
          createdAt: string | Date;
          description: string;
          files?: string[];
          status: string;
        }[];
      };
    }>(`/todo/employee/one/${todoId}`, {
      headers: {
        authorization: `Bearer ${employeeKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL TODOS ******
export const getAllPendingTodosForEmployee =
  (employeeKey: string) => (data: { status?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        todos?: {
          _id: string;
          createdAt: Date | string;
          files: string[];
          title: string;
          description: string;
          recipients: {
            _id: string;
            name: string;
          }[];
          tasks: {
            _id: string;
            createdAt: string | Date;
            files: string[];
            recipient: string;
            status: string;
            description: string;
          }[];
          deadline: string | Date;
        }[];
      }>(`/todo/employee/todo-by-status`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
